export function getGuidFromUrl(url: string): string {
  const vesselId = window.location.pathname.replaceAll('/', '');
  return isGuid(vesselId) ? vesselId : '';
}

export function isGuid(guid: string): boolean {
  const regexExp = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi;
  return regexExp.test(guid);
}
